(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-custom copy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const initSizeCharts = () => {
      document.querySelectorAll('[data-size-chart-component]').forEach((component) => {
        if (component.dataset.initialized === 'true') return;
        component.dataset.initialized = 'true';

        const openBtn = component.querySelector('[data-size-chart-open]');
        const modalId = `SizeChartModal-${component.dataset.productId}`;
        let modal = component.querySelector('.size-chart-modal') || document.getElementById(modalId);

        // Remove any stale duplicate modal on body if theme re-rendered section
        const existingBodyModal = document.body.querySelector(`:scope > #${modalId}`);
        if (existingBodyModal && existingBodyModal !== modal) {
          existingBodyModal.remove();
        }

        // Teleport modal directly to document.body so it breaks free from parent containers
        if (modal && modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }

        const closeElements = modal ? modal.querySelectorAll('[data-size-chart-close]') : [];
        const unitBtns = modal ? modal.querySelectorAll('[data-unit-set]') : [];
        const unitLabel = modal ? modal.querySelector('[data-unit-label]') : null;
        const skuDisplay = modal ? modal.querySelector('[data-active-sku-display]') : null;
        const table = modal ? modal.querySelector('.size-chart-table') : null;
        const jsonScript = modal ? modal.querySelector('[data-sku-chart-data]') : component.querySelector('[data-sku-chart-data]');
        let skuData = {};

        if (jsonScript) {
          try {
            skuData = JSON.parse(jsonScript.textContent);
          } catch (e) {
            console.error('Failed to parse size chart data', e);
          }
        }

        const openModal = () => {
          if (!modal) return;
          if (modal.parentElement !== document.body) {
            document.body.appendChild(modal);
          }
          modal.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
          if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        };

        const closeModal = () => {
          if (!modal) return;
          modal.setAttribute('hidden', '');
          document.body.style.overflow = '';
          if (openBtn) {
            openBtn.setAttribute('aria-expanded', 'false');
            openBtn.focus();
          }
        };

        if (openBtn) {
          openBtn.addEventListener('click', openModal);
        }

        closeElements.forEach((el) => {
          el.addEventListener('click', closeModal);
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
            closeModal();
          }
        });

        const updateUnit = (unit) => {
          component.dataset.currentUnit = unit;
          if (modal) modal.dataset.currentUnit = unit;
          unitBtns.forEach((btn) => {
            const isActive = btn.dataset.unitSet === unit;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          if (unitLabel) {
            unitLabel.textContent = unit === 'cm' ? 'dimensions in centimeters' : 'dimensions in inches';
          }

          if (table) {
            table.querySelectorAll('tbody td').forEach((cell) => {
              const val = cell.getAttribute(`data-${unit}`);
              if (val) {
                cell.textContent = val;
              }
            });
          }
        };

        unitBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            updateUnit(btn.dataset.unitSet);
          });
        });

        const updateSkuChart = (rawSku) => {
          if (!rawSku) return;
          const cleanSku = String(rawSku).trim().toUpperCase();
          let matchedSkuKey = null;

          for (const key in skuData) {
            if (cleanSku.includes(key.toUpperCase())) {
              matchedSkuKey = key;
              break;
            }
          }

          if (!matchedSkuKey) return;

          component.dataset.activeSku = matchedSkuKey;
          if (modal) modal.dataset.activeSku = matchedSkuKey;
          if (skuDisplay) skuDisplay.textContent = matchedSkuKey;

          const chartInfo = skuData[matchedSkuKey];
          if (!chartInfo || !chartInfo.rows) return;

          const currentUnit = component.dataset.currentUnit || 'in';

          Object.keys(chartInfo.rows).forEach((rowKey) => {
            const rowEl = table.querySelector(`tr[data-row="${rowKey}"]`);
            if (rowEl) {
              const cells = rowEl.querySelectorAll('td');
              const valuesInches = chartInfo.rows[rowKey];
              cells.forEach((cell, idx) => {
                if (valuesInches[idx] !== undefined) {
                  const valIn = Number(valuesInches[idx]).toFixed(1);
                  const valCm = (valuesInches[idx] * 2.54).toFixed(1);
                  cell.setAttribute('data-in', valIn);
                  cell.setAttribute('data-cm', valCm);
                  cell.textContent = currentUnit === 'cm' ? valCm : valIn;
                }
              });
            }
          });
        };

        const variantsScript = component.querySelector('[data-product-variants]');
        let variantsList = [];
        if (variantsScript) {
          try {
            variantsList = JSON.parse(variantsScript.textContent);
          } catch (e) {
            console.error('Failed to parse product variants', e);
          }
        }

        const updateSkuFromVariantId = (variantId) => {
          if (!variantId || !variantsList.length) return;
          const found = variantsList.find((v) => String(v.id) === String(variantId));
          if (found && found.sku) {
            updateSkuChart(found.sku);
          }
        };

        const form = component.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        if (form) {
          form.addEventListener('change', () => {
            const variantIdInput = form.querySelector('[name="id"]');
            if (variantIdInput) {
              updateSkuFromVariantId(variantIdInput.value);
            }
          });
        }

        document.querySelectorAll('variant-selects, variant-radios').forEach((picker) => {
          picker.addEventListener('change', () => {
            setTimeout(() => {
              const urlParams = new URLSearchParams(window.location.search);
              const vId = urlParams.get('variant');
              if (vId) {
                updateSkuFromVariantId(vId);
              }
            }, 50);
          });
        });

        document.addEventListener('variant:change', (e) => {
          if (e.detail && e.detail.variant && e.detail.variant.sku) {
            updateSkuChart(e.detail.variant.sku);
          } else if (e.detail && e.detail.variant && e.detail.variant.id) {
            updateSkuFromVariantId(e.detail.variant.id);
          }
        });

        window.addEventListener('popstate', () => {
          const urlParams = new URLSearchParams(window.location.search);
          const vId = urlParams.get('variant');
          if (vId) {
            updateSkuFromVariantId(vId);
          }
        });
      });
    };

    initSizeCharts();
    document.addEventListener('shopify:section:load', initSizeCharts);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chart-custom"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const initSizeCharts = () => {
      document.querySelectorAll('[data-size-chart-component]').forEach((component) => {
        if (component.dataset.initialized === 'true') return;
        component.dataset.initialized = 'true';

        const openBtn = component.querySelector('[data-size-chart-open]');
        const modalId = `SizeChartModal-${component.dataset.productId}`;
        let modal = component.querySelector('.size-chart-modal') || document.getElementById(modalId);

        // Remove any stale duplicate modal on body if theme re-rendered section
        const existingBodyModal = document.body.querySelector(`:scope > #${modalId}`);
        if (existingBodyModal && existingBodyModal !== modal) {
          existingBodyModal.remove();
        }

        // Teleport modal directly to document.body so it breaks free from parent containers
        if (modal && modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }

        const closeElements = modal ? modal.querySelectorAll('[data-size-chart-close]') : [];
        const unitBtns = modal ? modal.querySelectorAll('[data-unit-set]') : [];
        const unitLabel = modal ? modal.querySelector('[data-unit-label]') : null;
        const tablesWrapper = modal ? modal.querySelector('[data-size-chart-tables-wrapper]') : null;
        const jsonScript = component.querySelector('[data-sku-chart-data]');
        let skuData = {};

        if (jsonScript) {
          try {
            skuData = JSON.parse(jsonScript.textContent);
          } catch (e) {
            console.error('Failed to parse size chart data', e);
          }
        }

        const openModal = () => {
          if (!modal) return;
          if (modal.parentElement !== document.body) {
            document.body.appendChild(modal);
          }
          modal.removeAttribute('hidden');
          document.documentElement.classList.add('size-chart-modal-open');
          document.body.classList.add('size-chart-modal-open');
          if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        };

        const closeModal = () => {
          if (!modal) return;
          modal.setAttribute('hidden', '');
          document.documentElement.classList.remove('size-chart-modal-open');
          document.body.classList.remove('size-chart-modal-open');
          if (openBtn) {
            openBtn.setAttribute('aria-expanded', 'false');
            openBtn.focus();
          }
        };

        if (openBtn) {
          openBtn.addEventListener('click', openModal);
        }

        closeElements.forEach((el) => {
          el.addEventListener('click', closeModal);
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
            closeModal();
          }
        });

        const updateUnit = (unit) => {
          component.dataset.currentUnit = unit;
          if (modal) modal.dataset.currentUnit = unit;

          unitBtns.forEach((btn) => {
            const isActive = btn.dataset.unitSet === unit;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          if (unitLabel) {
            unitLabel.textContent = unit === 'cm' ? 'dimensions in centimeters' : 'dimensions in inches';
          }

          if (modal) {
            modal.querySelectorAll('.size-chart-table tbody td').forEach((cell) => {
              const val = cell.getAttribute(`data-${unit}`);
              if (val) {
                cell.textContent = val;
              }
            });
          }
        };

        unitBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            updateUnit(btn.dataset.unitSet);
          });
        });

        const formatMeasurement = (value, unit) => {
          const sourceValue = String(value).trim();
          if (unit === 'in') return sourceValue;

          return sourceValue.replace(/\d+(?:\.\d+)?/g, (number) => {
            return (Number(number) * 2.54).toFixed(1);
          });
        };

        const createTableElement = (chartInfo, titleText) => {
          const block = document.createElement('div');
          block.className = 'size-chart-table-block';

          if (titleText) {
            const titleEl = document.createElement('h3');
            titleEl.className = 'size-chart-table-title';
            titleEl.textContent = titleText;
            block.appendChild(titleEl);
          }

          const container = document.createElement('div');
          container.className = 'size-chart-table-container';

          const table = document.createElement('table');
          table.className = 'size-chart-table';

          const thead = document.createElement('thead');
          thead.setAttribute('data-size-chart-head', '');
          const headerRow = document.createElement('tr');

          // Left header cell above measurements
          const thMeasurement = document.createElement('th');
          thMeasurement.scope = 'col';
          thMeasurement.className = 'th-measurement';
          thMeasurement.textContent = 'Measurement';
          headerRow.appendChild(thMeasurement);

          // Size header columns with dark header bar
          (chartInfo.sizes || []).forEach((size) => {
            const thSize = document.createElement('th');
            thSize.scope = 'col';
            thSize.className = 'th-size';
            thSize.textContent = size;
            headerRow.appendChild(thSize);
          });
          thead.appendChild(headerRow);
          table.appendChild(thead);

          const tbody = document.createElement('tbody');
          tbody.setAttribute('data-size-chart-body', '');

          if (!chartInfo.rows || !chartInfo.rows.length) {
            const emptyRow = document.createElement('tr');
            const emptyCell = document.createElement('td');
            emptyCell.colSpan = Math.max((chartInfo.sizes || []).length + 1, 2);
            emptyCell.className = 'size-chart-table__empty';
            emptyCell.textContent = 'Measurements are not available for this product.';
            emptyRow.appendChild(emptyCell);
            tbody.appendChild(emptyRow);
          } else {
            const currentUnit = component.dataset.currentUnit || 'in';
            chartInfo.rows.forEach((row) => {
              const tr = document.createElement('tr');
              const th = document.createElement('th');
              th.scope = 'row';
              th.className = 'td-measurement';
              th.textContent = row.label;
              tr.appendChild(th);

              row.values.forEach((val) => {
                const td = document.createElement('td');
                const inchVal = String(val).trim();
                const cmVal = formatMeasurement(inchVal, 'cm');
                td.setAttribute('data-in', inchVal);
                td.setAttribute('data-cm', cmVal);
                td.textContent = currentUnit === 'cm' ? cmVal : inchVal;
                tr.appendChild(td);
              });
              tbody.appendChild(tr);
            });
          }

          table.appendChild(tbody);
          container.appendChild(table);
          block.appendChild(container);
          return block;
        };

        const renderCharts = (chartsList) => {
          if (!tablesWrapper) return;
          tablesWrapper.textContent = '';

          const isMultiple = chartsList.length > 1;
          chartsList.forEach((chartInfo) => {
            const titleText = isMultiple ? (chartInfo.title || '') : '';
            const tableBlock = createTableElement(chartInfo, titleText);
            tablesWrapper.appendChild(tableBlock);
          });
        };

        const updateSkuChart = (rawSku) => {
          const cleanSku = String(rawSku || '')
            .trim()
            .toUpperCase();

          const normalizeSku = (str) => String(str || '').replace(/[\s_-]+/g, '').toUpperCase();
          const normClean = normalizeSku(cleanSku);

          let matchedSkuKey = Object.keys(skuData).find((key) => cleanSku === key.toUpperCase());
          if (!matchedSkuKey) {
            matchedSkuKey = Object.keys(skuData).find((key) => normClean && normClean === normalizeSku(key));
          }
          if (!matchedSkuKey) {
            const sortedKeys = Object.keys(skuData).sort((a, b) => b.length - a.length);
            matchedSkuKey = sortedKeys.find((key) => cleanSku.includes(key.toUpperCase()) || (normClean && normClean.includes(normalizeSku(key))));
          }

          if (!matchedSkuKey) {
            renderCharts([{ sizes: [], rows: [] }]);
            return;
          }

          component.dataset.activeSku = matchedSkuKey;
          if (modal) modal.dataset.activeSku = matchedSkuKey;

          const data = skuData[matchedSkuKey];
          const charts = data.charts && data.charts.length > 0 ? data.charts : [data];
          renderCharts(charts);
        };

        updateSkuChart(component.dataset.activeSku);

        const variantsScript = component.querySelector('[data-product-variants]');
        let variantsList = [];
        if (variantsScript) {
          try {
            variantsList = JSON.parse(variantsScript.textContent);
          } catch (e) {
            console.error('Failed to parse product variants', e);
          }
        }

        const updateSkuFromVariantId = (variantId) => {
          if (!variantId || !variantsList.length) return;
          const found = variantsList.find((v) => String(v.id) === String(variantId));
          if (found && found.sku) {
            updateSkuChart(found.sku);
          }
        };

        const form =
          component.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
        if (form) {
          form.addEventListener('change', () => {
            const variantIdInput = form.querySelector('[name="id"]');
            if (variantIdInput) {
              updateSkuFromVariantId(variantIdInput.value);
            }
          });
        }

        document.querySelectorAll('variant-selects, variant-radios').forEach((picker) => {
          picker.addEventListener('change', () => {
            setTimeout(() => {
              const urlParams = new URLSearchParams(window.location.search);
              const vId = urlParams.get('variant');
              if (vId) {
                updateSkuFromVariantId(vId);
              }
            }, 50);
          });
        });

        document.addEventListener('variant:change', (e) => {
          if (e.detail && e.detail.variant && e.detail.variant.sku) {
            updateSkuChart(e.detail.variant.sku);
          } else if (e.detail && e.detail.variant && e.detail.variant.id) {
            updateSkuFromVariantId(e.detail.variant.id);
          }
        });

        window.addEventListener('popstate', () => {
          const urlParams = new URLSearchParams(window.location.search);
          const vId = urlParams.get('variant');
          if (vId) {
            updateSkuFromVariantId(vId);
          }
        });
      });
    };

    initSizeCharts();
    document.addEventListener('shopify:section:load', initSizeCharts);
  });
  } catch(e) { console.error(e); }
})();

})();
